exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container {\r\n    text-align: center;\r\n    max-width: 900px;\r\n    width: 100%;\r\n}\r\n\r\nblockquote.quote {\r\n    font-family: \"Myriad Pro\";\r\n    font-size: 36px;\r\n    line-height: 40px;\r\n    color: #c0c0c0;\r\n    text-align: left;\r\n    border-left: none;\r\n}\r\n\r\n\r\n\r\n.separator {\r\n    margin-top: 45px;\r\n    margin-bottom: 20px;\r\n    max-width: 900px;\r\n    width: 100%;\r\n    height: 1px;\r\n    background-color: #c0c0c0;\r\n}\r\n\r\n.author {\r\n    font-family: \"Corbel\";\r\n    font-size: 18px;\r\n    color: #90acb9;\r\n    line-height: 18px;\r\n    float: right;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/quote/quote.component.css
// module id = 761
// module chunks = 1